export default "__VITE_ASSET__BJt5o6tP__"